module.exports = __webpack_public_path__ + "static/media/tablet.cc10808a.png";